import DeptPage from "@/pages/zones/DeptPage";
import { departmentsData } from "@/mocks/departments";

export default function Paris75Page() {
  return <DeptPage dept={departmentsData["paris-75"]} />;
}
